/**
 * Copyright IBM Corp. 2022, 2026
 */

'use client'

import { FlightIcon } from '../../flight-icon'
import { useMenuPrimitive } from '../../menu-primitive/use-menu-primitive'
import s from '../style.module.scss'

export const TruncationButton = ({
	ariaLabel = 'show more',
}: {
	ariaLabel?: string
}) => {
	const { isOpen, onClickToggle } = useMenuPrimitive()

	return (
		<button
			type="button"
			className={s['truncation-button']}
			aria-label={ariaLabel}
			aria-expanded={isOpen}
			onClick={onClickToggle}
		>
			<FlightIcon name="more-horizontal" />
		</button>
	)
}
